export const buttonPurple =
  "bg-brand-purple hover:bg-brand-purple-dark gradient-slide gradient-slide--purple active:scale-95";
export const ribbin = "bg-status-success/40";
